import Phaser from "phaser";

function playerTextureKey(scene: Phaser.Scene): { key: string; frame?: number } {
  if (scene.anims.exists("player-idle")) {
    return { key: "player-spritesheet", frame: 0 };
  }
  if (scene.textures.exists("player-spritesheet")) {
    return { key: "player-spritesheet", frame: 0 };
  }
  if (scene.textures.exists("player-idle")) {
    return { key: "player-idle" };
  }
  return { key: "player-placeholder" };
}

export class IdlePreview extends Phaser.GameObjects.Sprite {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    const texture = playerTextureKey(scene);
    super(scene, x, y, texture.key, texture.frame);
    scene.add.existing(this);
    this.setOrigin(0.5, 1);

    const grid = scene.registry.get("playerSpritesheetGrid") as
      | { frameHeight: number }
      | undefined;
    const targetHeight = 96;
    const scale = grid ? targetHeight / grid.frameHeight : 2;
    this.setScale(scale);

    if (scene.anims.exists("player-idle")) {
      this.play("player-idle");
    } else {
      scene.tweens.add({
        targets: this,
        y: y - 4,
        duration: 900,
        yoyo: true,
        repeat: -1,
        ease: "Sine.easeInOut",
      });
    }
  }

  playBump(): void {
    const baseX = this.scaleX;
    const baseY = this.scaleY;
    this.scene.tweens.add({
      targets: this,
      scaleX: baseX * 1.08,
      scaleY: baseY * 0.92,
      duration: 80,
      yoyo: true,
      ease: "Quad.easeOut",
    });
  }
}
